import { BvTableFieldArray } from 'bootstrap-vue';

export const transceiverTableFields: BvTableFieldArray = [
	{ key: 'id', label: 'Id', sortable: true },
	{ key: 'feedTankName', label: 'Tank Name', sortable: true },
	{ key: 'createdAt', label: 'Created', sortable: true },
	{ key: 'serialNumber', label: 'Serial Number', sortable: true },
	{ key: 'imei', label: 'IMEI', sortable: true },
	{ key: 'firmwareVersion', label: 'Firmware' },
	{ key: 'lastCheckIn', label: 'Last Check In' },
	{ key: 'reboot', label: 'Reboot' },
];
